/**
 * Redux slice for app configuration (countries, settings, etc.)
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SupportedCountry } from '../../types/config';
import { fetchSupportedCountries, initializeConfig } from './configThunks';

interface ConfigState {
  supportedCountries: SupportedCountry[];
  isLoadingCountries: boolean;
  countriesError: string | null;
  isInitialized: boolean;
}

const initialState: ConfigState = {
  supportedCountries: [],
  isLoadingCountries: false,
  countriesError: null,
  isInitialized: false,
};

const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    resetConfigError: (state) => {
      state.countriesError = null;
    },
  },
  extraReducers: (builder) => {
    // Fetch supported countries
    builder.addCase(fetchSupportedCountries.pending, (state) => {
      state.isLoadingCountries = true;
      state.countriesError = null;
    });
    builder.addCase(
      fetchSupportedCountries.fulfilled,
      (state, action: PayloadAction<SupportedCountry[] | undefined>) => {
        state.supportedCountries = action.payload || [];
        state.isLoadingCountries = false;
        state.isInitialized = true;
      },
    );
    builder.addCase(fetchSupportedCountries.rejected, (state, action) => {
      state.isLoadingCountries = false;
      state.countriesError = action.payload as string;
      state.isInitialized = true;
    });

    // Initialize config
    builder.addCase(initializeConfig.fulfilled, (state) => {
      state.isInitialized = true;
    });
  },
});

export const { resetConfigError } = configSlice.actions;
export default configSlice.reducer;
